import { Button, ControlLabel, FormControl, FormGroup } from "react-bootstrap";
import React, { Component } from "react";

import CompanySelectSiren from "../Company/CompanySelectSiren";
import CountrySelect from "../Country/CountrySelect";
import { FormattedMessage } from "react-intl";
import Queries from "../../queries/queries2";
import { graphql } from "react-apollo";

class ClientFormInfos extends Component {
  constructor() {
    super();

    this.state = {
      showSirenSearch: false
    };
  }

  toggleSiren = () => {
    this.setState({ showSirenSearch: true });
  };

  render = () => {
    const {
      updateFormValue,
      name,
      address,
      country,
      handleOnSelected,
      getCountry,
      focusNameInput
    } = this.props;

    // console.log("ClientFormInfos name:", name);

    return (
      <div>
        <h4>
          <FormattedMessage id="ids_infos" />
        </h4>
        {/*<FormGroup>
        <ControlLabel>
          <FormattedMessage id='ids_name'
                            description="client name input field label"
                            defaultMessage="Nom"
          />
        </ControlLabel>
        <FormControl
            name="name"
            value={name}
            onChange={(e) => updateFormValue("name", e.target)}
        />
      </FormGroup>
      */}
        <FormGroup>
          <ControlLabel>
            <FormattedMessage
              id="ids_name"
              description="supplier name input field label"
              defaultMessage="Nom"
            />
          </ControlLabel>

          {this.state.showSirenSearch ? (
            <CompanySelectSiren
              value={name}
              autoFocus={focusNameInput}
              onSelected={value => {
                handleOnSelected(value);
                this.setState({ showSirenSearch: false });
              }}
            />
          ) : (
            <FormControl
              name="name"
              value={name}
              onChange={e => updateFormValue("name", e.target)}
            />
          )}
          <Button onClick={this.toggleSiren}>
            {" "}
            <i className="fa fa-search" />
          </Button>
        </FormGroup>

        <FormGroup>
          <ControlLabel>
            <FormattedMessage
              id="ids_address"
              description="client address input field label"
              defaultMessage="Adresse"
            />
          </ControlLabel>
          <FormControl
            componentClass="textarea"
            rows="6"
            name="adresse"
            id="address"
            value={address}
            placeholder="Adresse"
            onChange={event => updateFormValue("address", event.target)}
          />
        </FormGroup>
        <FormattedMessage id="ids_country">
          {placeholder => (
            <div>
              <FormGroup>
                <ControlLabel>{placeholder}</ControlLabel>
                <CountrySelect
                  required
                  value={
                    country !== ""
                      ? country
                      : getCountry &&
                        getCountry.country &&
                        getCountry.country.id
                  }
                  onSelected={e => updateFormValue("country", e)}
                  placeholder={placeholder}
                />
              </FormGroup>
            </div>
          )}
        </FormattedMessage>
      </div>
    );
  };
}
export default graphql(Queries.GetCountryByLabel, {
  options: ({ countryCode }) => ({
    variables: { label: (countryCode && { countryCode }.countryCode) || "FR" }
  }),
  name: "getCountry"
})(ClientFormInfos);
